import React from 'react'
import CoursesManagement from '../../pages-partial/CourseManagement'

const Courses = () => {
  return (
    <div><CoursesManagement /></div>
  )
}

export default Courses